import * as React from "react";
import { inject, observer } from "mobx-react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import { Profile, WorkExperience, Demographics } from "../../models/profile";
import { BusyEvent } from "../../models/enums";
import { LinearProgress } from "material-ui/Progress";
import { Grid, Row, Col } from "react-flexbox-grid";
import { ILocalization } from "../../models/localization";
import { EditProfileAction, UploadResumeAction, AddExperienceAction, DownloadPdfAction } from "../../components/profile/actions";
import CredentialSummary from "../../components/profile/credentialSummary";
import LanguageSummary from "../../components/profile/languageSummary";
import SummaryContainer from "../../components/profile/summaryContainer";
import LangEditor from "../../components/profile/langEditor";
import EditorContainer from "../../components/profile/editorContainer";
import Busy from "../../components/widgets/busy";
import * as s from "./profile.css";

@inject("store") @observer
export default class ProfileVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount() {
    if (!this.props.store.viewState.requireAuthentication()) {
      return;
    }
    if (!this.props.store.profileStore.profile) {
      this.props.store.profileStore.loadProfile();
    }
    window.scrollTo(0, 0);
  }
  componentDidMount(): void {
    this.props.store.getHelpTopics();
  }

  renderActionsRow(): JSX.Element {
    return (
      <Row className={s.row}>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><EditProfileAction store={this.props.store} /></Col>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><UploadResumeAction store={this.props.store} /></Col>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><DownloadPdfAction store={this.props.store} /></Col>
      </Row>);
  }
  renderSummaryRow(): JSX.Element {
    return (
      <Row className={s.row}>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><AddExperienceAction store={this.props.store} /></Col>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><CredentialSummary store={this.props.store} /></Col>
        <Col xs={12} sm={12} md={4} lg={4} className={s.col}><LanguageSummary store={this.props.store} fromResume={false} /></Col>
      </Row>);
  }
  renderContainerRow(): JSX.Element {
    return (
      <Row className={s.row}>
        <Col xs={12} sm={12} md={5} lg={5} xl={4} className={s.col}><SummaryContainer store={this.props.store} /></Col>
        <Col xs={12} sm={12} md={7} lg={7} xl={8} className={s.col}><EditorContainer store={this.props.store} /></Col>
      </Row>);
  }

  render(): JSX.Element {
    return (
      <div>
        <Busy show={this.props.store.viewState.isBusy(BusyEvent.LoadProfile)} size="lg" center={true} />
        {!this.props.store.viewState.isBusy(BusyEvent.LoadProfile) && <Grid className={s.profileGrid}>
          {this.renderActionsRow()}
          {this.renderSummaryRow()}
          {this.renderContainerRow()}
          {this.props.store.viewState.isBusy(BusyEvent.GeneratingNonSpecificProfile) && <Busy show={true} center={true} size="med" msg={this.props.store.localization.fields.generating} />}
        </Grid>}
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/views/profile/index.tsx